import React, { useState, useEffect } from "react";
import sendRequest from "../utils/sendRequest";
import validators from "../utils/validators";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Navbar from "../components/Navbar";
import swal from "sweetalert";
import Loader from "../components/Loader";
import { checkAuth } from "../utils/checkAuth";
import { Link } from "react-router-dom";
import { UserTypeContext } from "../MyContext";
import { useContext } from "react";
import SecureLS from "secure-ls";
import { encrypt } from "../utils/cipher";
import "./../css/Landing.css"
const domains = {
  SEBIUSER: "sebi.gov.in",
  KFIN: "kfintech.com",
  CAMS: "cams.com",
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: "auto",
    maxHeight: 600,
    width: 800,
    maxWidth: 900,
    borderRadius: 5,
    boxShadow: "0px 3px 15px #BCB0B0",
    background: " #EEEEEE",
    display: "flex",
    justifyContent: "space-evenly",
  },
  textFieldBox: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Roboto-Bold",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#272782",
    width: "35%",
    marginBottom: "25px",
  },
  rowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    width: "100%",
  },
  title: {
    display: "flex",
    alignItems: "center",
    color: "#272782",
    fontWeight: "400",
    height: "45px",
    left: "702px",
    top: "340px",
    fontFamily: "Roboto-Medium",
    fontStyle: "normal",
    fontSize: "36px",
    lineHeight: "42px",
  },
  container: {
    width: "100%",
    height: "80%",
    display: "flex !important",
    justifyContent: "center !important",
    alignItems: "center !important"

  },
  card: {

  },

  [theme.breakpoints.down("md")]: {
    root: {
      height: "auto",
      marginTop: 10,
      maxHeight: 650,
      marginLeft: "0%",
      width: "100%",
      maxWidth: 900,
      borderRadius: 5,
      boxShadow: "0px 3px 15px #BCB0B0",
      background: " #EEEEEE",
      display: "flex",
      justifyContent: "space-evenly",
    },
  },

  [theme.breakpoints.down("xs")]: {
    root: {
      height: "auto",
      marginTop: 10,
      maxHeight: 650,
      marginLeft: "5%",
      width: "90%",
      maxWidth: 900,
      borderRadius: 5,
      boxShadow: "0px 3px 15px #BCB0B0",
      background: " #EEEEEE",
      display: "flex",
      justifyContent: "space-evenly",
    },
    rowContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      alignItems: "center",
      width: "80%",
    },
    textFieldBox: {
      display: "flex",
      flexDirection: "column",
      fontFamily: "Roboto-Bold",
      fontSize: "16px",
      lineHeight: "19px",
      color: "#272782",
      width: "75%",
      marginBottom: "25px",
    },
  },
}));

let styles = {
  title: {
    display: "flex",
    alignItems: "center",
    color: "#272782",
    fontWeight: "400",
    height: "45px",
    left: "702px",
    top: "340px",
    fontFamily: "Roboto-Medium",
    fontStyle: "normal",
    fontSize: "26px",
    lineHeight: "42px",
  },
};
const theme = createTheme();

function Landing() {
  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    mobile: "",
    userType: "",
  };
  const ls = new SecureLS();
  const { userType, setUserType } = useContext(UserTypeContext);
  const [input, setInput] = useState(initialState);
  const [loader, setLoader] = useState(false);
  let navigate = useNavigate();
  let kfinAdmin = ls.get("email");

  // console.log("kfin admin ", kfinAdmin)
  // useEffect(() => {
  //   (async () => {
  //     let authenticated = await checkAuth();
  //     if (!authenticated) navigate("/Login");
  //   })();
  // }, []);

  function handleChange(event) {
    const { name, value } = event.target;

    setInput((prevInput) => ({
      ...prevInput,
      [name]: value,
    }));
  }

  //   -----------------------SubmitHandler---------------------
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    // console.log(input);
    const isValid = validateFields(input);

    if (isValid) {
      let encryptedPayload = encrypt(input)
      sendRequest("api/auth/Demo", { payload: encryptedPayload })
        .then((result) => {
          // console.log(result);
          if (result.type === "success") {
            setInput(initialState);
            setLoader(false);
            swal("Done", "User Demoed Successfully", "success");
          } else {
            setLoader(false);
            swal("", result.message, "warning");
          }
        })
        .catch((error) => {
          setLoader(false);
          swal("", error, "error");
        });
    } else {
      setLoader(false);
      swal("", "Please fill all fields correctly", "warning");
    }
    // console.log("button clicked");
  };
  // console.log(userType, "<<<<<<<<<<<<<<<<<<<<<<<<<")
  function validateFields(login) {
    let validEmail = validators.validateEmail(login.email);
    let validPassword = validators.validatePassword(login.password);
    let validPhone = validators.validatePhoneNumber(login.mobile);
    let validUser = validators.validateUserType(
      login.userType,
      domains,
      login.email
    );

    if (!validEmail.isValid) swal("", validEmail.message, "warning");
    else if (!validPassword.isValid) swal("", validPassword.message, "warning");
    else if (!validPhone.isValid) swal("", validPhone.message, "warning");
    else if (!validUser.isValid) swal("", validUser.message, "warning");

    return (
      validEmail.isValid &&
      validPhone.isValid &&
      validPassword.isValid &&
      validUser.isValid
    );
  }

  const autoSelectUser = () => {
    const domain = input.email.split("@")[1];
    let user = "";

    if (domain === domains.SEBIUSER) user = "SEBIUSER";
    else if (domain === domains.KFIN || domain === domains.CAMS) user = "APMII";
    else user = "PMS";

    setInput((prevInput) => ({
      ...prevInput,
      userType: user,
    }));
  };

  const cardStyles = useStyles(theme);
  return (

    <ThemeProvider theme={theme}>
      <Navbar />
      <Loader visible={loader} />
      <Container fixed style={{ height: "70%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Card className={cardStyles.root} sx={{ boxShadow: 8, borderRadius: "8px" }}>

          <Box sx={{ marginY: "70px", width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box className="title">
                <Typography className="typography" component="h1" variant="h5" sx={styles.title}>
                  Select a User Type to Proceed ...
                </Typography>
              </Box>
              <div style={{ display: "flex", gap: "5%", marginTop: "60px", marginBottom: "50px" }}>
                {kfinAdmin == "admin@apmiindia.org" || kfinAdmin == "admin@kfintech.com" ? (
                  <div  className="buttons" style={{ display: "flex", gap: "5%", }}>
                    <Link to="/Register" style={{ textDecoration: "none" }}>
                      <Button
                        className={cardStyles.Button}
                        type="submit"
                        variant="contained"
                        onClick={() => {
                          setUserType("PMS");
                          ls.set("userType", "PMS");
                        }}
                        sx={{
                          bgcolor: "transparent",
                          mt: 5,
                          border: "2px solid #272782",
                          width: "150px",
                          borderRadius: 1,
                          height: 55,
                          fontWeight: 600,
                          fontSize: "16px",
                          lineHeight: "23px",
                          display: "flex",
                          align: "center",
                          color: "#272782",
                          textDecoration: "none",
                          "&:hover": { bgcolor: "#272782", color: "white" },
                        }}
                      >
                        <span style={{ padding: 10 }}>PMS{" "}</span>
                      </Button>
                    </Link>
                    <Link to="/Register" style={{ textDecoration: "none" }}>
                      <Button
                        className={cardStyles.Button}
                        type="submit"
                        variant="contained"
                        onClick={() => {
                          setUserType("APMII");
                          ls.set("userType", "APMII");
                        }}
                        sx={{
                          bgcolor: "transparent",
                          mt: 5,
                          border: "2px solid #272782",
                          width: "150px",
                          borderRadius: 1,
                          height: 55,
                          fontWeight: 600,
                          fontSize: "16px",
                          lineHeight: "23px",
                          display: "flex",
                          align: "center",
                          color: "#272782",
                          "&:hover": { bgcolor: "#272782", color: "white" },
                        }}
                      >
                        <span style={{ padding: 10 }}>APMI{" "}</span>
                      </Button>
                    </Link>
                  </div>

                ) : (
                  <div>
                    <Link to="/Register" style={{ textDecoration: "none" }}>
                      <Button
                        className={cardStyles.Button}
                        type="submit"
                        variant="contained"
                        onClick={() => { setUserType("SEBI"); ls.set("userType", "SEBI"); }}
                        sx={{
                          bgcolor: "transparent",
                          mt: 5,
                          border: "2px solid #272782",
                          width: "150px",
                          borderRadius: 1,
                          height: 55,
                          fontWeight: 600,
                          fontSize: "16px",
                          lineHeight: "23px",
                          display: "flex",
                          align: "center",
                          color: "#272782",
                          '&:hover': {
                            bgcolor: "#272782",
                            color: "white"
                          }
                        }}
                      >
                        <span style={{ padding: 10 }}>SEBI{"     "}</span>
                      </Button>
                    </Link>
                  </div>

                )}



              </div>
              {/* <Box
                sx={{
                  width: "85%",
                  height: "2px",
                  backgroundColor: "#272782",
                  marginTop: "10px",
                  marginBottom: "40px",
                }}
              /> */}
            </Box>

          </Box>
        </Card>
      </Container>
    </ThemeProvider>

  );
}

export default Landing;
